export const SET_DATA = 'SET_DATA';
export const SET_VARIANT_SIZE = 'SET_VARIANT_SIZE';
export const RESET_DATA = 'RESET_DATA';
export const SET_PRODUCT_SIZE = 'SET_PRODUCT_SIZE';
export const INCREMENT_OPTION = 'INCREMENT_OPTION';
export const DECREMENT_OPTION = 'DECREMENT_OPTION';
export const SELECT_INGREDIENT = 'SELECT_INGREDIENT';
export const REMOVE_TOPPINGS = 'REMOVE_TOPPINGS';
export const SELECT_TOPPING = 'SELECT_TOPPING';
export const PDP_CONTINUE = 'PDP_CONTINUE';
export const PDP_MIAM_CONTINUE = 'PDP_MIAM_CONTINUE';
export const INCREMENT_MIAM_OPTION = 'INCREMENT_MIAM_OPTION';
export const DECREMENT_MIAM_OPTION = 'DECREMENT_MIAM_OPTION';
export const SELECT_MIAM_INGREDIENT = 'SELECT_MIAM_INGREDIENT';
export const HANDLE_BACK ='HANDLE_BACK';
export const SHOW_MORE = 'SHOW_MORE';
export const ADD_TO_BAG = 'ADD_TO_BAG';
export const SHOW_MODAL_DATA = 'SHOW_MODAL_DATA';
export const CONFIRMATION_MODAL_DATA = 'CONFIRMATION_MODAL_DATA';

